import { useState } from 'react';
import { useFeatureServices } from './use-feature-services';

import { useLogger } from './use-logger';
import { useUniversalEffect } from './use-universal-effect';
import { SharedConfigurationsResult } from '../types/shared-configs';
import fetchSharedConfigs from '../fetch-data/fetch-shared-configs';

export function useProvideSharedConfigs():
  | SharedConfigurationsResult
  | undefined {
  const [sharedConfigs, setSharedConfigs] = useState<
    SharedConfigurationsResult | undefined
  >({
    salesEventOffersIds: {},
    specialEventConfig: {
      filterOptions: [],
    },
    offerTagsConfig: {
      defaultText: '',
      overwriteDefaultIcon: '',
      enable: false,
    },
    modelOrder: [],
    disclaimers: {
      landing: [],
      results: [],
      details: [],
    },
    mappedTrimName: {},
  });
  const logger = useLogger();

  const {
    's2:async-ssr-manager': asyncSsrManager,
    'service-config-provider': serviceConfigProvider,
    's2:server-request': serverRequest,
  } = useFeatureServices();

  useUniversalEffect(() => {
    const fetchSharedConfigsPromise = fetchSharedConfigs(
      serviceConfigProvider,
      serverRequest,
    )
      ?.then((res) => {
        if (res) setSharedConfigs(res);
      })
      .catch((error) => {
        logger.error(error);
      });

    if (asyncSsrManager) {
      asyncSsrManager.scheduleRerender(fetchSharedConfigsPromise);
    }
  }, [asyncSsrManager, serviceConfigProvider, serverRequest, logger]);

  return sharedConfigs;
}
